var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M12.3111 18.1659C8.36876 24.9942 10.7083 33.7254 17.5366 37.6677C24.3648 41.61 33.0961 39.2705 37.0384 32.4422C40.9807 25.614 38.6411 16.8827 31.8129 12.9404",
    stroke: "#292929",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0609 33.6554C44.8934 25.2853 42.0256 14.5825 33.6554 9.75C25.2853 4.91751 14.5825 7.78532 9.75 16.1554C4.91751 24.5256 7.78532 35.2284 16.1554 40.0609",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2857 25.9643H25.4643V30.7857C25.4643 31.3161 25.0304 31.75 24.5 31.75C23.9696 31.75 23.5357 31.3161 23.5357 30.7857V25.9643H18.7143C18.1839 25.9643 17.75 25.5304 17.75 25C17.75 24.4696 18.1839 24.0357 18.7143 24.0357H23.5357V19.2143C23.5357 18.6839 23.9696 18.25 24.5 18.25C25.0304 18.25 25.4643 18.6839 25.4643 19.2143V24.0357H30.2857C30.8161 24.0357 31.25 24.4696 31.25 25C31.25 25.5304 30.8161 25.9643 30.2857 25.9643Z",
    fill: "#292929",
    stroke: "#F6F6F6",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAdd);
export default __webpack_public_path__ + "static/media/upload-add.184d7160101c20bb88be1310d1b52528.svg";
export { ForwardRef as ReactComponent };